import * as React from 'react';
import {DropDownRouteData} from "../../../../navigation/route/HeaderRoutes";
import User from "../../../../model/user/User";
import "./headerSubMenu.scss"
import {RootState} from "../../../../store/reducer/root/RootState";
import {connect} from "react-redux";

interface ReduxProps {
	/**
	 * Logged in user.
	 */
	user: User;
}

interface ComponentProps {
	/**
	 * On menu item click handler.
	 * @param {string} url Url to redirect to.
	 */
	onItemClick: (url: string) => void;
	/**
	 * Routes to display.
	 */
	routes: DropDownRouteData [];
}

type Props = ComponentProps & ReduxProps;

class HeaderSubMenu extends React.Component<Props, {}> {
	render() {
		return (
			<ul className={"c-header-submenu"}>
				{this.props.routes.map((route, index) => {
					return this.props.user.hasPermissions(route.allowedPermissions) && (
						<li key={index} className="c-header-submenu_item" onClick={event => {
							// Kept from the item above, which on a touch screen would toggle the submenu open again.
							event.stopPropagation();
							this.props.onItemClick(route.route);
						}}>
							{route.label}
						</li>
					)
				})}
			</ul>
		);
	}
}


function mapStateToProps(state: RootState) {
	return {
		user: state.user.user.get
	}
}

export default connect(mapStateToProps)(HeaderSubMenu)